import React from 'react'
import './UserHome.css';
import { BreadCrumb } from "primereact/breadcrumb";
import { Link } from 'react-router-dom';

function UserHome() {
    const iconItemTemplate = (item: any, options: any) => {
        return (
            <Link to={''} className="header-link text-dsGray">
                <span className={item.icon}></span> { item.label }
            </Link>
        );
    };
    const items = [
        { label: 'Home', template: iconItemTemplate },
        { label: 'Link', template: iconItemTemplate }
    ];
    const home = { icon: 'pi pi-home', url: 'https://primereact.org' };
    
    return (
        <div className='flex h-screen overflow-y-hidden w-full'>
            {/* sidebar */}
            <div className='w-2/12 bg-gray-300 user-home-navbar-effects'>
                {/* logo */}
                {/* <div className='flex w-full justify-center p-4 text-center'>
                    <Link to={'/'}>
                        <img className='w-4/5 h-auto' src="assets/img/logobig.png" alt="" />
                    </Link>
                </div> */}
                <a href={'/'} style={{ textDecoration: 'none' }}>
                <div className='mt-2 text-4xl py-0 font-bold text-dsBlue font-Poppins w-full text-center flex items-center justify-center'>
                    <img src="assets/img/logoIcono.png" style={{ height: '32px', width: 'auto' }} alt="" />
                    <p className='p-0 m-0 uppercase'>Autoneg</p> 
                    <span className='font-Roboto text-red-700 text-sm'>&nbsp;3.0</span>
                </div>
                <div className='text-xl py-0 font-bold text-green-800 font-Roboto w-full text-center'>Facturacion <span className='text-text-green-800'>Electronica</span></div>
                </a>
                {/* menu */}
                <div className='mt-8 px-6 w-full '>
                    <div>
                        {/* grupo */}
                        <div className='font-bold mb-2 mt-2 flex items-center text-[16px]'>
                            Comprobantes
                        </div>
                        <div>
                            <ul className='mt-0 pl-0 space-y-3' style={{textDecoration: 'none', listStyle: 'none'}}>
                                <li className='flex items-center text-[16px]'><i style={{fontSize: '16px'}} className="material-icons-outlined md-18 ">dashboard</i>&nbsp; Resumen</li>
                                <li className='flex items-center text-[16px]'><i style={{fontSize: '16px'}} className="material-icons-outlined md-18 ">call_made</i>&nbsp; Emitidos</li>
                                <li className='flex items-center text-[16px]'><i style={{fontSize: '16px'}} className="material-icons-outlined md-18 ">call_received</i> &nbsp;Recibidos</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        {/* grupo */}
                        <div className='font-bold mb-2 flex items-center text-[16px] mt-12'>
                            Usuario
                        </div>
                        <div>
                            <ul className='mt-0 pl-0 space-y-2' style={{textDecoration: 'none', listStyle: 'none'}}>
                                <li className='flex items-center text-[16px]'><i style={{fontSize: '16px'}} className="material-icons-outlined md-18 ">person</i>&nbsp; Perfil</li>
                                <li className='flex items-center text-[16px]'><i style={{fontSize: '16px'}} className="material-icons-outlined md-18 ">manage_accounts</i>&nbsp; Configuracion</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {/* content */}
            <div className='w-10/12 bg-dsgray overflow-y-auto'>
                <div className='w-full min-h-full flex flex-col'>
                    <div className='px-4 py-2 ds-container-bottom-shadow flex'>
                        {/* <div className='text-4xl py-0 font-bold text-dsGray font-Roboto'>Facturacion <span className='text-dsGray'>Electronica</span></div> */}
                        <div className='w-8/12 flex flex-col space-y-1'>
                            <div className='text-3xl py-0 text-dsGray font-bold font-Roboto'>Nombre de la compa&ntilde;ia</div>
                            <div className=''>
                                <BreadCrumb className='bg-dsgray font-bold border-0 py-0 px-0' model={items} home={home} />   
                            </div>
                        </div>
                        <div className='w-4/12  flex flex-col space-y-1'>
                            <div className='text-dsBlue font-bold text-lg truncate w-full text-right'>Juan Perez Martinez</div>
                            <div className='w-full '>
                                <Link className='flex items-center text-red-700 font-bold ds-link-default text-right justify-end ' to={'/'}>
                                    <i className="material-icons-outlined md-18">logout</i>
                                    Cerrar Sesi&oacute;n
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className='flex-auto px-4 blur-lg'>
                        
                    </div>
                    <div className=' min-h-[40px] px-4 text-dsGray font-bold flex flex-col lg:flex-row justify-between'>
                        <p>{new Date().getFullYear()} &copy; Racol Computers S.R.L.</p>
                        <p>Desarrollado Por Brian Almengo</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserHome;